var _rect, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashTop6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333252,
    width: 54,
    height: 54,
    rx: 8,
    fill: "#D1FAE5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.1665,
    cy: 26.5,
    r: 12.5,
    stroke: "#059669",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3853 23.0938L30.9506 24.5767H22.6665L23.1012 23.0938H31.3853ZM27.4989 33.0909L22.8199 27.3636L22.7943 26.2898H25.121C25.7262 26.2898 26.2418 26.2045 26.6679 26.0341C27.0941 25.8594 27.4201 25.5994 27.6459 25.2543C27.8718 24.9048 27.9847 24.4659 27.9847 23.9375C27.9847 23.1577 27.7503 22.5462 27.2816 22.103C26.8128 21.6555 26.0926 21.4318 25.121 21.4318H22.6665L23.1012 20H25.121C26.1608 20 27.0131 20.1726 27.6779 20.5178C28.3469 20.8587 28.8412 21.3274 29.1608 21.924C29.4847 22.5163 29.6466 23.1875 29.6466 23.9375C29.6466 24.6151 29.4975 25.2393 29.1992 25.8104C28.9051 26.3771 28.4321 26.8331 27.7801 27.1783C27.1324 27.5234 26.2759 27.696 25.2105 27.696H25.1722L29.4932 32.9886V33.0909H27.4989ZM31.3853 20L30.9506 21.483L24.4307 21.4318L24.8654 20H31.3853Z",
    fill: "#059669"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashTop6);
export default __webpack_public_path__ + "static/media/dash-top-6.93d6e533a11933c1f978102b987c12cd.svg";
export { ForwardRef as ReactComponent };